// Galerie de sections prêtes à l'emploi, aux couleurs de PROXIreduc (#E05638 / #172A3A).
// Les blocs n'ont pas d'id : le constructeur les ré-identifie à l'insertion.
const INK = "#172A3A";

export const SECTION_PRESETS = [
  {
    key: "hero", name: "Héros", desc: "Grande accroche + bouton",
    build: () => ({
      type: "section", data: { bg: INK, paddingY: "lg", maxWidth: "wide" },
      columns: [{ blocks: [
        { type: "heading", data: { text: "Le meilleur du local, près de chez vous", level: "2", align: "center", textColor: "#ffffff" } },
        { type: "richtext", data: { html: "<p>Découvrez les commerces, bons plans et événements d'Eure-et-Loir, réunis au même endroit.</p>", align: "center", textColor: "#e2e8f0" } },
        { type: "button", data: { label: "Demander un devis", href: "/demande-de-devis", style: "primary", align: "center" } },
      ] }],
    }),
  },
  {
    key: "features", name: "Atouts (3 colonnes)", desc: "Trois arguments",
    build: () => ({
      type: "section", data: { bg: "", paddingY: "lg", maxWidth: "normal" },
      columns: [
        { blocks: [{ type: "heading", data: { text: "Proximité", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p>Des partenaires près de chez vous, partout en Eure-et-Loir.</p>", align: "center" } }] },
        { blocks: [{ type: "heading", data: { text: "Confiance", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p>Des professionnels vérifiés et des avis authentiques.</p>", align: "center" } }] },
        { blocks: [{ type: "heading", data: { text: "Simplicité", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p>Demandez un devis en quelques clics, sans engagement.</p>", align: "center" } }] },
      ],
    }),
  },
  {
    key: "pricing", name: "Tarifs (3 colonnes)", desc: "Trois offres",
    build: () => ({
      type: "section", data: { bg: "", paddingY: "lg", maxWidth: "normal" },
      columns: [
        { blocks: [{ type: "heading", data: { text: "Découverte", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p><strong>Gratuit</strong></p><ul><li>Fiche de base</li><li>Visible localement</li></ul>", align: "center" } }, { type: "button", data: { label: "Commencer", href: "/devenir-partenaire", style: "outline", align: "center" } }] },
        { blocks: [{ type: "heading", data: { text: "Pro", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p><strong>29€/mois</strong></p><ul><li>Mini-site</li><li>Demandes de devis</li><li>Mise en avant</li></ul>", align: "center" } }, { type: "button", data: { label: "Choisir Pro", href: "/devenir-partenaire", style: "primary", align: "center" } }] },
        { blocks: [{ type: "heading", data: { text: "Premium", level: "3", align: "center" } }, { type: "richtext", data: { html: "<p><strong>Sur devis</strong></p><ul><li>Accompagnement</li><li>Campagnes ciblées</li></ul>", align: "center" } }, { type: "button", data: { label: "Nous contacter", href: "/contact", style: "outline", align: "center" } }] },
      ],
    }),
  },
  {
    key: "testimonials", name: "Témoignages (2 colonnes)", desc: "Avis clients",
    build: () => ({
      type: "section", data: { bg: "#FAF4F1", paddingY: "lg", maxWidth: "normal" },
      columns: [
        { blocks: [{ type: "richtext", data: { html: "<p><em>« Un service local vraiment pratique, j'ai trouvé mon artisan en une journée. »</em></p><p><strong>— Camille, Chartres</strong></p>" } }] },
        { blocks: [{ type: "richtext", data: { html: "<p><em>« Enfin une plateforme qui met en avant nos commerces de proximité ! »</em></p><p><strong>— Karim, Dreux</strong></p>" } }] },
      ],
    }),
  },
  {
    key: "faq", name: "FAQ", desc: "Questions fréquentes",
    build: () => ({
      type: "section", data: { bg: "", paddingY: "lg", maxWidth: "narrow" },
      columns: [{ blocks: [
        { type: "heading", data: { text: "Questions fréquentes", level: "2", align: "center" } },
        { type: "richtext", data: { html: "<p><strong>Comment demander un devis ?</strong></p><p>Cliquez sur « Demander un devis » et décrivez votre besoin.</p><p><strong>Est-ce gratuit ?</strong></p><p>Oui, la demande de devis est 100% gratuite et sans engagement.</p>" } }],
      }],
    }),
  },
  {
    key: "cta", name: "Appel à l'action", desc: "Bandeau de conversion",
    build: () => ({
      type: "section", data: { bg: INK, paddingY: "lg", maxWidth: "normal" },
      columns: [{ blocks: [
        { type: "heading", data: { text: "Prêt à soutenir le commerce local ?", level: "2", align: "center", textColor: "#ffffff" } },
        { type: "button", data: { label: "Demander un devis gratuit", href: "/demande-de-devis", style: "primary", align: "center" } },
      ] }],
    }),
  },
];
